// 'use client';

import { TIPS } from '@ice-web-app/shared-constants';
import { Box } from '@mui/material';
import { DsIcon } from '../../../../components/icons/DsIcon';
// Hook Imports
import useVerticalNav from '../../../@menu/hooks/useVerticalNav';

export const VerticalNavToggle = () => {
  // Hooks
  const { toggleVerticalNav, isBreakpointReached } = useVerticalNav();

  const handleClick = () => {
    toggleVerticalNav();
  };

  return (
    <>
      {/* <DsIcon size="lg" icon="JUSTIFIED" onClick={handleClick} /> */}
      {/* Comment following code and uncomment above code in order to toggle menu on desktop screens as well */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      {isBreakpointReached && (
        <Box data-tour={TIPS.LAYOUT.SIDEBAR.TOGGLE_BUTTON.DATA} onClick={handleClick}>
          <DsIcon size="lg" icon="JUSTIFIED" />
        </Box>
      )}
    </>
  );
};
